import React, { FC, ChangeEvent } from 'react';
import BaseField, { FieldStatus } from '../BaseField/BaseField';
import style from '../inputs.module.css';

interface ColorFieldProps {
  name?: string;
  label?: string;
  error?: string;
  touched?: boolean;
  value?: string; // color en formato #hex
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  status?: FieldStatus;
  classNameInput?: string;
}

const ColorField: FC<ColorFieldProps> = ({
  name,
  label,
  error,
  touched,
  value,
  onChange,
  onBlur,
  disabled,
  status,
  classNameInput,
}) => {
  const computedStatus: FieldStatus = 'default';

  const handleHexChange = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (/^#?[0-9A-Fa-f]{0,6}$/.test(val)) {
      onChange?.({
        target: { name: name || '', value: val.startsWith('#') ? val : `#${val}` },
      } as React.ChangeEvent<HTMLInputElement>);
    }
  };

  const handleColorChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.({
      target: { name: name || '', value: e.target.value },
    } as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <BaseField
      label={label}
      error={error}
      touched={touched}
      status={computedStatus}
      indicatorColor={undefined}
      onClear={undefined}
    >
      <div style={{ position: 'relative', width: '100%' }}>
        {/* Input hex */}
        <input
          type="text"
          name={name}
          id={name}
          value={value ?? ''}
          onChange={handleHexChange}
          onBlur={onBlur}
          disabled={disabled}
          placeholder="#FFFFFF"
          className={`${classNameInput || style.input__input} ${error ? style.inputError : ''}`}
          style={{ paddingRight: '40px' }}
        />

        {/* Input de color posicionado como círculo */}
        <input
          type="color"
          value={value ?? '#000000'}
          onChange={handleColorChange}
          disabled={disabled}
          className={style.colorInputCircle}
        />
      </div>
    </BaseField>
  );
};

export default ColorField;